export enum BOOKING_STATUS_CODE {
  ACTIVE = 1,
  CANCELLED = 2,
  FINISHED = 10,
  WAITING_TO_SIGN = 12,
}

// Temporarily hides the medical issues field in the EHR book appointment dialog
export const SHOW_EHR_APPOINTMENT_MEDICAL_ISSUES = false
